/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Map_Note_FreeInputs */

const en_us2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A target counts 1 set, a synergist ½. With no plan, the colour compares the muscles with each other, never below 4 sets.`)
};

const pt_br2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alvo conta 1 série, sinergista conta ½. Sem plano, a cor compara os músculos entre si, com piso de 4 séries.`)
};

const es_419_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un objetivo cuenta 1 serie, un sinergista ½. Sin plan, el color compara los músculos entre sí, con un mínimo de 4 series.`)
};

const pt_pt2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um alvo conta 1 série, um sinergista conta ½. Sem plano, a cor compara os músculos entre si, com um mínimo de 4 séries.`)
};

const fr_fr2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscle cible compte 1 série, un synergiste ½. Sans programme, la couleur compare les muscles entre eux, avec un minimum de 4 séries.`)
};

const de_de2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Zielmuskel zählt 1 Satz, ein Synergist ½. Ohne Plan vergleicht die Farbe die Muskeln untereinander, nie unter 4 Sätzen.`)
};

const it_it2_progress_extra_map_note_free = /** @type {(inputs: Progress_Extra_Map_Note_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un muscolo principale conta 1 serie, un sinergico ½. Senza scheda, il colore confronta i muscoli tra loro, mai sotto le 4 serie.`)
};

/**
* | output |
* | --- |
* | "A target counts 1 set, a synergist ½. With no plan, the colour compares the muscles with each other, never below 4 sets." |
*
* @param {Progress_Extra_Map_Note_FreeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_note_free = /** @type {((inputs?: Progress_Extra_Map_Note_FreeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_Note_FreeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_note_free(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_note_free(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_note_free(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_note_free(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_note_free(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_note_free(inputs)
	return en_us2_progress_extra_map_note_free(inputs)
});
export { progress_extra_map_note_free as "progress-extra.map_note_free" }